import { BdAppConfigRequest, BdAppConfigResponse } from '@bindoc-projects/app-config-domain-lib';

export class BdApplicationBootstrap {

  public static loadFrontendConfig(
    request: BdAppConfigRequest,
    environment: {
      configRequestUrl: string,
    }
  ): Promise<BdAppConfigResponse> {
    let isPageUnloading = false;
    const onBeforeUnload = (): void => {
      isPageUnloading = true;
    };
    window.addEventListener('beforeunload', onBeforeUnload);

    return fetch(environment.configRequestUrl, {
      method: 'GET',
      mode: 'cors',
      headers: new Headers({
        'content-type': 'application/json'
      })
    })
      .then((res) => res.json())
      .catch((error: unknown) => {
        if (isPageUnloading) {
          // Page is navigating away (e.g. MSAL redirect) — the config
          // is no longer needed. Return a pending promise so bootstrap
          // stalls silently until the redirect completes.
          // eslint-disable-next-line @typescript-eslint/no-empty-function -- intentionally never-resolving
          return new Promise<BdAppConfigResponse>(() => {});
        }
        throw error;
      })
      .finally(() => {
        window.removeEventListener('beforeunload', onBeforeUnload);
      });
  }
}
